import { ChallengeService } from '@duck/api-definitions'
import { Button } from '@duck/ui'
import { useTar } from '@/modules'
import { useSubmitToReview } from '@/hooks/useSubmitToReview'

interface WorkspaceStatusPaneProps {
    challenge: ChallengeService.Challenge
    hasCharts: boolean
}

export const WorkspaceStatusPane = ({ challenge, hasCharts }: WorkspaceStatusPaneProps) => {
    const { t } = useTar()
    const { handleSubmit } = useSubmitToReview()

    return (
        <div className="flex w-full p-2 items-center justify-center h-12 bg-card">
            <div className="flex flex-1 items-center justify-end">
                <Button
                    onClick={handleSubmit}
                    size="sm"
                    variant="outline"
                    className="px-24 text-foreground border-primary/70 h-8"
                    data-tour-id="submit-solution"
                >
                    {t('common.submit')}
                </Button>
            </div>
        </div>
    )
}


